/**
 * Layout das abas — port de app/(tabs)/_layout.tsx.
 *
 * < 1024px: coluna única como no app (tela + BottomBar embaixo).
 * ≥ 1024px: menu lateral à esquerda + conteúdo; a BottomBar some (CSS dela).
 * WEB: o swipe-back do iOS é o "voltar" do próprio browser/gesto do Safari.
 */
import BottomBar from "@/components/navigation/BottomBar";
import PainelLateralDesktop from "@/components/desktop/PainelLateralDesktop";
import MenuLateral from "@/components/navigation/MenuLateral";
import { useRef } from "react";
import { Outlet } from "react-router";
import { useFaixaSincronizada } from "./useFaixaSincronizada";
import s from "./TabsLayout.module.css";

export default function TabsLayout() {
  const mainRef = useRef<HTMLElement | null>(null);
  // Desktop largo: faixa azul do painel direito sempre na altura da faixa da tela.
  useFaixaSincronizada(mainRef);
  return (
    <div className={s.raiz}>
      <aside className={s.lateral}>
        <MenuLateral />
      </aside>
      <div className={s.coluna}>
        <main ref={mainRef} className={s.conteudo}>
          <Outlet />
        </main>
        <BottomBar />
      </div>
      {/* Desktop largo (≥1440px): relógio, sincronização e calendário no espaço lateral. */}
      <aside className={s.painelDireito}>
        <PainelLateralDesktop />
      </aside>
    </div>
  );
}
